import React from 'react';

const RecordIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Outer circle with stroke */}
      <circle 
        cx="12" 
        cy="12" 
        r="11" 
        stroke="#F54B56" 
        strokeWidth="1" 
        fill="none"
      />
      {/* Inner filled circle */}
      <circle 
        cx="12" 
        cy="12" 
        r="8" 
        fill="#F54B56"
      />
    </svg>
  );
};

export default RecordIcon;